import React, { createElement, useCallback, useState } from "react"

interface ComponentInfo {
  component: React.JSXElementConstructor<Record<string, unknown>>
  props: Record<string, unknown>
}

type LoadComponent = <P extends Record<string, unknown>>(
  component: React.JSXElementConstructor<P>,
  props: P,
) => void

export const useLazyComponent = () => {
  const [lazyComponent, setLazyComponent] = useState<ComponentInfo | null>(null)

  const unloadComponent = useCallback(() => {
    setLazyComponent(null)
  }, [])

  const loadComponent: LoadComponent = useCallback((component, props) => {
    setLazyComponent({
      component: component as React.JSXElementConstructor<
        Record<string, unknown>
      >,
      props: {
        ...props,
        onClose: props.onClose ?? (() => setLazyComponent(null)),
      },
    })
  }, [])

  const renderLazyComponent = useCallback(() => {
    if (!lazyComponent) {
      return
    }

    return createElement(lazyComponent.component, lazyComponent.props)
  }, [lazyComponent])

  return {
    lazyComponent,
    loadComponent,
    unloadComponent,
    renderLazyComponent,
  }
}
